import { ExpandMore } from '@styled-icons/material-rounded/ExpandMore'
import styled, { css } from 'styled-components/macro'

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  padding: 36px 32px 86px;
`

export const WrapperFixed = styled.div`
  width: 100%;
  height: 100%;
  position: fixed;
`
export const Cabecalho = styled.div`
  display: grid;
  grid-template:
    'Voltar Voltar'
    'Terreno Terreno'
    'DataSimulacao EncolherTudo';
  padding-bottom: 16px;
  align-items: center;
  z-index: 1;
`
export const Voltar = styled.div`
  grid-area: Voltar;
  margin-bottom: 18px;
`
export const Terreno = styled.div`
  grid-area: Terreno;
`
export const DataSimulacaoEncolherTudo = styled.div`
  ${({ theme }) => css`
    font-size: ${theme.font.sizes.small};
    color: ${theme.colors.gray};
  `}
`
export const DataSimulacao = styled(DataSimulacaoEncolherTudo)`
  grid-area: DataSimulacao;
  justify-self: start;
`
export const EncolherTudo = styled(DataSimulacaoEncolherTudo)`
  grid-area: EncolherTudo;
  justify-self: end;
`
export const Rodape = styled.div`
  ${({ theme }) => css`
    background-color: ${theme.colors.secondary};
  `}
  width: 100%;
  height: 72px;
  position: fixed;
  bottom: 0;
  left: 0;
  display: grid;
  grid-auto-flow: column;
  align-items: center;
  justify-content: flex-end;
  grid-gap: 20px;
  padding: 0 32px;
`
export const IconeExpandir = styled(ExpandMore)`
  ${({ theme }) => css`
    color: ${theme.colors.gray4};
  `}
  height: 24px;
  width: 24px;
`

export const SecaoOpcional = styled.span`
  ${({ theme }) => css`
    color: ${theme.colors.gray};
    font-size: ${theme.font.sizes.small};
    font-weight: ${theme.font.normal};
  `}
  margin-left: 6px;
  margin-top: 4px;
  font-family: 'IBMPlexSans-Regular';
`
